import embedSagaWatchersChatActivity from 'embeds/sagas/sagaWatchersChatActivity';
import embedSagaWatchersMessage from 'embeds/sagas/sagaWatchersMessage';
import { fork } from 'redux-saga/effects';

import sagaWatchersChatActivity from './sagaWatchersChatActivity';
import sagaWatchersGroup from './sagaWatchersGroup';
import sagaWatchersGroupInvite from './sagaWatchersGroupInvite';
import sagaWatchersMessage from './sagaWatchersMessage';
import sagaWatchersMessageTemplate from './sagaWatchersMessageTemplate';
import sagaWatchersOffer from './sagaWatchersOffer';
import sagaWatchersPatient from './sagaWatchersPatient';
import sagaWatchersProvider from './sagaWatchersProvider';
import sagaWatchersReferral from './sagaWatchersReferral';
import sagaWatchersReminder from './sagaWatchersReminder';
import sagaWatchersTelehealth from './sagaWatchersTelehealth';
import sagaWatchersUser from './sagaWatchersUser';
import sagaWatchersViewer from './sagaWatchersViewer';
import sagaWatchersWaitingRoomPatient from './sagaWatchersWaitingRoomPatient';
import sagaWatchersWaitlist from './sagaWatchersWaitlist';

/**
 * Watchers to keep redux, relay, and react-query stores updated when the app receives
 * a socket event or a success mutation after a REST API call
 *
 * - Update redux store by normalizing the data and storing it inisde `normalizr.entities`
 * - Update relay store by updating the record dynamically
 * - TODO define pattern to update records/lookups inside react-query store
 */
export default function* sagaWatchers() {
  yield fork(embedSagaWatchersChatActivity);
  yield fork(embedSagaWatchersMessage);
  yield fork(sagaWatchersChatActivity);
  yield fork(sagaWatchersGroup);
  yield fork(sagaWatchersGroupInvite);
  yield fork(sagaWatchersMessage);
  yield fork(sagaWatchersMessageTemplate);
  yield fork(sagaWatchersOffer);
  yield fork(sagaWatchersPatient);
  yield fork(sagaWatchersReferral);
  yield fork(sagaWatchersReminder);
  yield fork(sagaWatchersTelehealth);
  yield fork(sagaWatchersUser);
  yield fork(sagaWatchersProvider);
  yield fork(sagaWatchersViewer);
  yield fork(sagaWatchersWaitingRoomPatient);
  yield fork(sagaWatchersWaitlist);
}
